import { Affix } from '@arco-design/web-react'
import React, { useState } from 'react'
import styled from 'styled-components'
import About1 from 'ASSETS/png/icon_about_1.png'
import { ReactComponent as About2 } from 'ASSETS/svg/icon_about_2.svg'
import { ReactComponent as IconAbout } from 'ASSETS/svg/icon_nav_about.svg'
import productImg from 'ASSETS/png/product.png'
import { reportTea } from 'UTILS/tea'
import ActiveButton from '../active-button'

const NavGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 688px;
  background: linear-gradient(359.64deg, rgba(245, 248, 255, 0.15) 0.3%, #edf2ff 99.67%);
`

const Container = styled.div`
  width: 343px;
  display: flex;
  justify-content: center;
  position: relative;
`

const Header = styled.div`
  width: 100vw;
  height: 56px;
  background: ${(props: { active: boolean }) =>
    props.active ? 'rgba(255, 255, 255, 0.8)' : 'unset'};
  backdrop-filter: ${(props: { active: boolean }) =>
    props.active ? 'blur(10px)' : 'blur(0px)'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  transform: ${(props: { active: boolean }) =>
    props.active ? 'translateY(-1px)' : 'unset'};
`

const Icon = styled(IconAbout)`
  cursor: pointer;
  width: 178px;
  height: 24px;
  transform: translateY(-2px);
`

const ActionContainer = styled.div`
  width: 128px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Text = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #1d2129;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ActiveText = styled(Text)`
  width: 72px;
  height: 24px;
  background: ${(props: { active: boolean }) => (props.active ? '#3370FF' : 'unset')};
  color: ${(props: { active: boolean }) => (props.active ? '#ffffff' : '#1D2129')};
  border-radius: ${(props: { active: boolean }) => (props.active ? '2px' : 'unset')};
  :hover {
    color: ${(props: { active: boolean }) => (props.active ? '#ffffff' : '#165dff')};
    background: ${(props: { active: boolean }) => (props.active ? '#2152D9' : 'unset')};
  }
`

const Title = styled.span`
  height: 96px;
  width: 192px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #1d2129;
`

const Content = styled.span`
  width: 279px;
  height: 88px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4e5969;
  opacity: 0.8;
`

const IconAbout1 = styled.img`
  position: absolute;
  top: 17px;
  left: 16px;
  width: 64px;
  height: 64px;
`
const IconAbout2 = styled(About2)`
  position: absolute;
  top: -24px;
  right: 25px;
  width: 64px;
  height: 64px;
`

const ProductImg = styled.img`
  user-select: none;
  pointer-events: none;
  object-fit: cover;
  box-shadow: 0px -0.311927px 12.4771px rgba(102, 112, 147, 0.1),
    0px 8.54966px 9.3578px rgba(193, 198, 215, 0.127269),
    0px 5.92738px 6.23853px rgba(193, 198, 215, 0.113998),
    0px 3.14114px 9.3578px rgba(193, 198, 215, 0.0815545);
  border-radius: 4px;
  width: 337px;
  height: 204px;
`

const Nav = () => {
  const [active, setActive] = useState(false)
  return (
    <NavGroupContainer>
      <Affix onChange={setActive}>
        <Header active={active}>
          <Container style={{ justifyContent: 'space-between' }}>
            <Icon onClick={() => window.open('/')}></Icon>
            <ActionContainer>
              <Text
                onClick={() => {
                  reportTea('click_advance', {
                    url_path: '/about',
                    type: 'nav',
                  })
                  window.open(
                    'https://www.volcengine.cn/products/imagex?utm_content=ImageX&utm_source=10zb5a&utm_term=ImageX-breif',
                  )
                }}
              >
                企业版
              </Text>
              <ActiveText
                onClick={() => {
                  reportTea('click_experience')
                  window.open('/')
                }}
                active={active}
              >
                立即体验
              </ActiveText>
            </ActionContainer>
          </Container>
        </Header>
      </Affix>
      <Container style={{ marginTop: '48px' }}>
        <Title>一站式图像 智能处理平台</Title>
        <IconAbout2></IconAbout2>
      </Container>
      <Container style={{ marginTop: '16px' }}>
        <Content>
          veImageX 体验版可实现针对 PNG、JPEG、GIF、WebP、HEIF、AVIF
          等多种格式图片的压缩处理，以及图片旋转、缩放、裁剪、图文水印等多种智能处理。
        </Content>
      </Container>
      <Container style={{ marginTop: '32px' }}>
        <ActiveButton
          onClick={() => {
            reportTea('click_experience')
            window.open('/')
          }}
        >
          立即体验
        </ActiveButton>
        <IconAbout1 src={About1} draggable="false"></IconAbout1>
      </Container>
      <Container style={{ marginTop: '52px' }}>
        <ProductImg src={productImg}></ProductImg>
      </Container>
    </NavGroupContainer>
  )
}

export default Nav
